import React from 'react';
import { FadeIn } from './FadeIn';
const reasons = [{
  num: '01',
  title: 'La trampa de la lógica interna',
  desc: 'Intentar "pensar de forma positiva" para detener un pensamiento negativo es como intentar apagar un incendio echándole aire. Estás usando la misma herramienta (el pensamiento) que creó el problema. Solo consigues que el fuego se propague.'
}, {
  num: '02',
  title: 'La meditación mal aplicada',
  desc: 'Te dijeron que "dejes la mente en blanco". Para un cerebro en estado de rumiación catastrófica, el silencio es una amenaza. Tu sistema interpreta el vacío como un espacio para que entren más peligros imaginarios. No necesitas silencio; necesitas una tarea mecánica dirigida.'
}, {
  num: '03',
  title: 'El enfoque en el "Por Qué" en lugar del "Cómo"',
  desc: 'La terapia convencional busca el origen de tus traumas. Eso es útil a largo plazo, pero no detiene el ruido mental a las 2 de la mañana cuando tienes una reunión en 6 horas. Conocer el origen del incendio no apaga las llamas. Necesitas un extintor, no un mapa del edificio.'
}];
export function WhyFailedSection() {
  return <section className="py-24 lg:py-32 bg-navy-900 border-t border-steel-800" data-id="element-167">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-168">
        <FadeIn data-id="element-169">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 text-center leading-tight" data-id="element-170">
            POR QUÉ LO QUE HAS INTENTADO{' '}
            <span className="text-amber-500 italic" data-id="element-171">HA FRACASADO</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-172">
          <div className="max-w-2xl mx-auto text-center mb-16" data-id="element-173">
            <p className="text-lg text-offwhite/80 leading-relaxed mb-4" data-id="element-174">
              Si estás leyendo esto, probablemente ya has intentado "calmarte".
              El problema es que los métodos tradicionales ignoran una verdad
              biológica:
            </p>
            <p className="text-xl sm:text-2xl font-serif text-white italic" data-id="element-175">
              El sobrepensamiento no es una decisión, es un bucle mecánico de
              alerta.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-176">
          <p className="text-center text-amber-500 font-bold tracking-widest text-sm uppercase mb-10" data-id="element-177">
            3 razones por las que nada te ha funcionado hasta hoy
          </p>
        </FadeIn>

        <div className="space-y-6" data-id="element-178">
          {reasons.map((reason, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-179">
              <div className="flex gap-6 p-8 bg-navy-800 border border-steel-800 rounded-sm relative overflow-hidden group hover:border-amber-500/30 transition-colors" data-id="element-180">
                <span className="text-5xl font-serif font-bold text-amber-500/20 shrink-0 leading-none select-none" data-id="element-181">
                  {reason.num}
                </span>
                <div data-id="element-182">
                  <h3 className="text-xl font-bold text-white mb-3 font-sans" data-id="element-183">
                    {reason.title}
                  </h3>
                  <p className="text-offwhite/80 leading-relaxed" data-id="element-184">
                    {reason.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-185">
          <div className="mt-16 pl-6 border-l-2 border-amber-500 py-2" data-id="element-186">
            <p className="text-xl sm:text-2xl font-serif text-white italic leading-snug" data-id="element-187">
              Este manual no busca "entender" tu mente. Busca intervenir en su
              funcionamiento técnico para forzar un reinicio del sistema en 4
              minutos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}